import React from "react";
import SFTypography from "../../typography";
import { SFStack } from "../../grid";
import UserAvatar from "../../avatar/userAvatar";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const StyledUserNameWrapper = styled(SFStack)(() => ({
  pointerEvents: "none",
  padding: "8px 10px 18px 10px",
}));

const StyledUserName = styled(SFTypography)(({ theme }) => ({
  lineHeight: "12px",
  paddingTop: "4px",
  textTransform: "none",
  color: theme.palette.grey600.main,
}));


const UserNameMenuItem = ({ username }) => {
  const { theme } = getStyled();
  
  return (
    <StyledUserNameWrapper alignItems="center" spacing={0.5}>
      <UserAvatar
        sx={{
          width: 24,
          height: 24,
          fontSize: 40,
        }}
        sxNoImage={{
          fontSize: 10,
          border: `2px solid ${theme.palette.black.main}`,
          color: theme.palette.grey600.main,
          bgcolor: theme.palette.white.main,
          fontWeight: 600,
          width: 24,
          height: 24,
        }}
        name={username}
      />
      <StyledUserName 
        color="grey600"
        variant="textLabel"
        align="center"
      >
        {username}
      </StyledUserName>
    </StyledUserNameWrapper>
  );
};

export default UserNameMenuItem;
